import { createBrowserHistory } from "history";
import getUserConfirmation from "./getUserConfirmation";

export default createBrowserHistory({
  getUserConfirmation
});
